@if ($items().length > 0) {
    <table>
        <thead>
            <tr>
                <th>Description</th>
                <th>SKU</th>
                <th>
                    Price
                    @if ($currencies().length > 1) {
                        <select (change)="onCurrencyChange($event)">
                            @for (currency of $currencies(); track currency) {
                                <option [value]="currency" [selected]="currency === $selectedCurrency()">{{ currency }}</option>
                            }
                        </select>
                    }
                </th>
                <th>Amount</th>
            </tr>
        </thead>
        <tbody>
            @for (item of $items(); track item.description) {
                <tr>
                    <td [matTooltip]="item.description">{{ item.description }}</td>
                    <td>{{ item.sku || "N/A" }}</td>
                    <td>{{ item.price | currency: item.currency }}</td>
                    <td>{{ item.amount }}</td>
                </tr>
            }
        </tbody>
    </table>
    <p class="vat-note">{{ $priceIncludesVat() ? "Prices include VAT" : "Prices exclude VAT" }}</p>
}
@if ($error()) {
    <p style="text-align: center; color: red">{{ $error() }}</p>
} @else if ($items().length === 0) {
    <p style="text-align: center">No prices to display.</p>
}
